import {useTenderCrud} from "../../../../shared/hooks/useTenderCrud";
import {CrudService} from "../../service";
import {Pagination} from "../../../../shared/paginations/Paginations";
import {CrudTable} from "../../../../shared/crud/CrudTable";
import {CrudCreate} from "../../../../shared/crud/CrudCreate";
import {CrudUpdate} from "../../../../shared/crud/CrudUpdate";
import {CrudDelete} from "../../../../shared/crud/CrudDelete";

export const IrrelevanceList = () => {
    const {
        page,
        handlePages,
        totalPages,
        listOfAllData,
        updateData,
        removeData,
        createData,
        selectedModalData,
        getCurrentDataID,
        changeHandler,
        showForm,
        setShowForm,
        filterData,
        selectedData
    } = useTenderCrud({
        getData: CrudService.getIrrelevance,
        getMany: CrudService.getIrrelevances,
        deleteData: CrudService.deleteIrrelevance,
        putData: CrudService.putIrrelevance,
        addData: CrudService.addIrrelevance
    });
    const tableHead = ['Reason', 'Created at', 'Updated at', 'Actions']

    return (
        <div className="col-12">
            <div className="row">
                <div className="col-12">
                    <CrudCreate showForm={showForm} setShowForm={setShowForm} createData={createData} mainField="reason"
                                title="Irrelevance"
                                changeHandler={changeHandler}/>
                </div>
            </div>
            <div className="row">
                <CrudTable filterData={filterData} getCurrentDataID={getCurrentDataID} title="Irrelevance"
                           isDeleteCrud={true}
                           tableHead={tableHead} mainField="reason"
                           listOfAllData={listOfAllData}/>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-end">
                {totalPages <= 1 ? '' :
                    <Pagination
                        page={page}
                        totalPages={totalPages}
                        handlePagination={handlePages}
                    />
                }
            </div>
            <CrudUpdate updateData={updateData} changeHandler={changeHandler} mainField="reason" title="Irrelevance"
                        selectedData={selectedData!}/>

            <CrudDelete removeData={removeData} selectedData={selectedData} mainField="reason"
                        selectedModalData={selectedModalData}/>
        </div>
    )
}